import { render, staticRenderFns } from "./FloatingV2.vue?vue&type=template&id=52a4bb2b&scoped=true&"
import script from "./FloatingV2.vue?vue&type=script&lang=js&"
export * from "./FloatingV2.vue?vue&type=script&lang=js&"
import style0 from "./FloatingV2.vue?vue&type=style&index=0&id=52a4bb2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a4bb2b",
  null
  
)

export default component.exports